module.exports = __webpack_public_path__ + "static/client-9022ee8c873b979a1fded5fcb9d4cd52.png";